import Flex from '@deprecated-ui/common/Flex';
import Text from '@deprecated-ui/common/Text';
import DATA_CY from 'constants/data-cy';
import { UserCheckbox } from '../styled';
import { ReceiverType } from '../utils';
import ReceiverItemAvatar from './ReceiverItemAvatar';

interface ReceiverItemProps {
  receiver: {
    id: string | number;
    name: string;
    avatar?: string;
    shortName?: string;
    type: ReceiverType;
    [key: string]: any;
  };
  onSelect: () => void;
  disabled: boolean;
  checked?: boolean;
}

function ReceiverItem({
  receiver,
  onSelect,
  checked,
  disabled,
}: ReceiverItemProps) {
  return (
    // @ts-expect-error
    <Flex width="100%" justify="space-between" align="center" mb="5px">
      <Flex align="center">
        <ReceiverItemAvatar
          name={receiver.name}
          shortName={receiver.shortName}
          src={receiver.avatar}
          type={receiver.type}
        />
        {/* @ts-expect-error */}
        <Text pl="12px" family="bold">
          {receiver.name}
        </Text>
      </Flex>
      <UserCheckbox
        checked={checked}
        onChange={onSelect}
        disabled={disabled && !checked}
        data-cy={`${DATA_CY.SHARE_POST.CHECKBOX}-${receiver.id}`}
      />
    </Flex>
  );
}

export default ReceiverItem;
